export const PostContentMock = {
  head: {
    productSkus: [
      '11258172',
      '10451618',
      '11340780',
      '10360327',
      '11782242',
      '11314963',
      '10878379',
      '10406410',
      '11220560',
      '11425289',
      '11351901',
      '11669538',
      '11686841',
    ],
  },
  content: [
    {
      node: 'element',
      type: 'p',
      props: {
        text:
          'When your hair becomes dehydrated, it can lead to severe dryness and subsequent damage. Learning what factors could be causing the dehydration is essential to keeping it healthy. If your hair is coloured or has been chemically treated, it increases the risk of dryness, so always make sure to include deep conditioning treatments in your haircare regime to keep it healthy.',
      },
    },
    {
      node: 'widget',
      type: 'media',
      props: {
        url: 'https://www.youtube.com/watch?v=mkggXE5e2yk',
        provider: 'youtube',
      },
    },
    {
      node: 'widget',
      type: 'media',
      props: {
        url: 'https://www.facebook.com/facebook/posts/234936741401259',
        provider: 'facebook',
      },
    },
    {
      node: 'widget',
      type: 'media',
      props: {
        url: 'https://twitter.com/interior/status/611193269532295168',
        provider: 'twitter',
      },
    },
    {
      node: 'widget',
      type: 'media',
      props: {
        url: 'https://www.instagram.com/p/CJq-B_RMRv4/',
        provider: 'instagram',
      },
    },
    {
      node: 'widget',
      type: 'media',
      props: {
        url: 'https://open.spotify.com/playlist/37i9dQZF1DWWQRwui0ExPn',
        provider: 'spotify',
      },
    },
    {
      node: 'widget',
      type: 'media',
      props: {
        url: 'https://www.tiktok.com/@scout2015/video/6718335390845095173',
        provider: 'tiktok',
      },
    },
    {
      node: 'widget',
      type: 'media',
      props: {
        url: 'https://www.pinterest.com/pin/139752394664775546/',
        provider: 'pinterest',
      },
    },
    {
      node: 'element',
      type: 'p',
      props: {
        text:
          "A nourishing shampoo is one of the easiest ways to combat dehydration and the damage that follows. By replenishing the lost moisture and hydration within the hair's fibres, they can start to repel damaging aggressors like weather, pollution and heat easily. We have put together a list of our 10 favourite shampoos for dry and damaged hair so you can keep your locks healthy, soft, shiny and hydrated.",
      },
    },
    {
      node: 'element',
      type: 'header',
      props: {
        level: 2,
        text: 'What are the key signs of dry and damaged hair?',
      },
    },
    {
      node: 'element',
      type: 'list',
      props: {
        type: 'unordered',
        items: [
          { node: 'element', type: 'text', props: { text: 'Split ends' } },
          { node: 'element', type: 'text', props: { text: 'Dullness' } },
          {
            node: 'element',
            type: 'text',
            props: { text: 'Hair easily breaks' },
          },
          { node: 'element', type: 'text', props: { text: 'Lack of volume' } },
          {
            node: 'element',
            type: 'text',
            props: { text: 'Hair falls out easily' },
          },
        ],
      },
    },
    {
      node: 'element',
      type: 'header',
      props: { level: 2, text: 'Top tips to remedy dry and damaged hair' },
    },
    {
      node: 'element',
      type: 'list',
      props: {
        type: 'ordered',
        items: [
          {
            node: 'element',
            type: 'text',
            props: {
              text:
                'Use a nourishing shampoo in place of your regular shampoo. This will help to lock in essential moisture.',
            },
          },
          {
            node: 'container',
            children: [
              {
                node: 'element',
                type: 'text',
                props: {
                  text:
                    'Use a hydrating hair mask twice a week to deeply condition and treat thirsty locks. ',
                },
              },
              {
                node: 'element',
                type: 'link',
                props: {
                  uri:
                    'https://www.lookfantastic.com/blog/advice/best-hair-masks-damaged-hair/',
                  target: 'blank',
                  text: 'Discover our favourites here',
                },
              },
              { node: 'element', type: 'text', props: { text: '.' } },
            ],
          },
          {
            node: 'container',
            children: [
              {
                node: 'element',
                type: 'text',
                props: {
                  text:
                    'Reduce your use of heat tools on your hair where possible. Instead use products like the ',
                },
              },
              {
                node: 'element',
                type: 'link',
                props: {
                  uri: 'https://www.lookfantastic.com/brands/aquis.list',
                  target: 'blank',
                  text: 'Aquis Hair Towel',
                },
              },
              {
                node: 'element',
                type: 'text',
                props: { text: ' to dry your hair naturally.' },
              },
            ],
          },
          {
            node: 'container',
            children: [
              {
                node: 'element',
                type: 'text',
                props: { text: 'When your hair is wet, use a ' },
              },
              {
                node: 'element',
                type: 'link',
                props: {
                  uri:
                    'https://www.lookfantastic.com/tangle-teezer-the-wet-detangler-hair-brush-serenity-blue/11669538.html',
                  target: 'blank',
                  text: 'detangling brush',
                },
              },
              {
                node: 'element',
                type: 'text',
                props: {
                  text:
                    ' in place of your regular one. This will help reduce pressure and breakage on your hair fibres.',
                },
              },
            ],
          },
          {
            node: 'container',
            children: [
              {
                node: 'element',
                type: 'text',
                props: { text: 'Wrap your hair in a ' },
              },
              {
                node: 'element',
                type: 'link',
                props: {
                  uri:
                    'https://www.lookfantastic.com/silke-hair-wrap-the-sofia-champagne/11686841.html',
                  target: 'blank',
                  text: 'silk turban',
                },
              },
              {
                node: 'element',
                type: 'text',
                props: {
                  text: ' when sleeping to prevent stress and breakage.',
                },
              },
            ],
          },
        ],
      },
    },
    {
      node: 'widget',
      type: 'productRecommendations',
      props: { skus: ['11351901', '11669538', '11686841'] },
    },
    {
      node: 'element',
      type: 'table',
      props: {
        content:
          '<table width="662"><tbody><tr><td width="76"><strong>Rank #</strong></td><td width="378"><strong>Top 10 Beauty Products Worldwide</strong></td><td width="208"><strong>Number of Countries at No.1</strong></td></tr><tr><td width="76">1</td><td width="378">MAC Lipstick Velvet Teddy</td><td width="208">46</td></tr><tr><td width="76">2</td><td width="378">Benefit Theyre Real Lengthening Mascara</td><td width="208">21</td></tr><tr><td width="76">3</td><td width="378">Anastasia Beverly Hills Dipbrow Pomade</td><td width="208">20</td></tr><tr><td width="76">4</td><td width="378">Laura Mercier Translucent Loose Setting Powder</td><td width="208">9</td></tr><tr><td width="76">5</td><td width="378">MAC Lip Pencil Cork</td><td width="208">8</td></tr><tr><td width="76">6</td><td width="378">Maybelline Hyper Precise All Day Liner</td><td width="208">8</td></tr><tr><td width="76">7</td><td width="378">Estée Lauder Double Wear</td><td width="208">4</td></tr><tr><td width="76">8</td><td width="378">Urban Decay Naked 3</td><td width="208">3</td></tr><tr><td width="76">9</td><td width="378">MAC Mineralize Skinfinish Highlighter</td><td width="208">3</td></tr><tr><td width="76">10</td><td width="378">Too Faced Lip Plumper</td><td width="208"><strong>1</strong></td></tr></tbody></table><br />',
      },
    },
    {
      node: 'element',
      type: 'header',
      props: {
        level: 2,
        text: 'Which are the best shampoos for dry and damaged hair?',
      },
    },
    {
      node: 'element',
      type: 'list',
      props: {
        type: 'ordered',
        items: [
          {
            node: 'element',
            type: 'link',
            props: {
              uri:
                'https://www.lookfantastic.com/kerastase-nutritive-bain-satin-2-250ml/11258172.html',
              target: 'blank',
              text: 'K\u00e9rastase Nutritive Bain Satin 2',
            },
          },
          {
            node: 'element',
            type: 'link',
            props: {
              uri:
                'https://www.lookfantastic.com/pureology-hydrate-colour-care-shampoo-250ml/10451618.html',
              target: 'blank',
              text: 'Pureology Hydate Colour Care Shampoo',
            },
          },
          {
            node: 'element',
            type: 'link',
            props: {
              uri:
                'https://www.lookfantastic.com/shu-uemura-art-of-hair-urban-moisture-shampoo-300ml/11340780.html',
              target: 'blank',
              text: 'Shu Uemura Art of Hair Urban Moisture Shampoo',
            },
          },
          {
            node: 'element',
            type: 'link',
            props: {
              uri:
                'https://www.lookfantastic.com/alterna-caviar-anti-ageing-seasilk-moisture-shampoo-250ml/10360327.html',
              target: 'blank',
              text: 'Alterna Caviar Anti-Ageing Seasilk Moisture Shampoo',
            },
          },
          {
            node: 'element',
            type: 'link',
            props: {
              uri:
                'https://www.lookfantastic.com/l-oreal-professionnel-source-essentielle-ultimate-nourishment-duo/11782242.html',
              target: 'blank',
              text:
                "L'Or\u00e9al Professionnel Source Essentielle Ultimate Nourishment Duo",
            },
          },
          {
            node: 'element',
            type: 'link',
            props: {
              uri:
                'https://www.lookfantastic.com/system-professional-hydrate-shampoo-250ml/11314963.html',
              target: 'blank',
              text: 'System Professional Hydrate Shampoo',
            },
          },
          {
            node: 'element',
            type: 'link',
            props: {
              uri:
                'https://www.lookfantastic.com/aveda-dry-remedy-shampoo-250ml/10878379.html',
              target: 'blank',
              text: 'Aveda Dry Remedy Shampoo',
            },
          },
          {
            node: 'element',
            type: 'link',
            props: {
              uri:
                'https://www.lookfantastic.com/moroccanoil-moisture-repair-shampoo-250ml/10406410.html',
              target: 'blank',
              text: 'Moroccanoil Moisture Repair Shampoo',
            },
          },
          {
            node: 'element',
            type: 'link',
            props: {
              uri:
                'https://www.lookfantastic.com/leonor-greyl-bain-vitalisant-b-specific-shampoo-for-dry-colored-sensitive-hair/11220560.html',
              target: 'blank',
              text: 'Leonor Greyl Bain Vitalisant B',
            },
          },
          {
            node: 'element',
            type: 'link',
            props: {
              uri:
                'https://www.lookfantastic.com/biolage-r.a.w.-nourish-shampoo-325ml/11425289.html',
              target: 'blank',
              text: 'Biolage R.A.W Nourish Shampoo',
            },
          },
        ],
      },
    },
    {
      node: 'widget',
      type: 'topN',
      props: {
        items: [
          {
            sku: '11258172',
            title: 'K\u00e9rastase Nutritive Bain Satin 2',
            description:
              'The <a href="https://www.lookfantastic.com/kerastase-nutritive-bain-satin-2-250ml/11258172.html" target="_blank" rel="noopener">K\u00e9rastase Nutritive Bain Satin 2</a> is undoubtedly one of the best shampoos to remedy dry and damaged hair thanks to its nourishing properties.\r\n\r\nInfused with the brand\'s exclusive Irisome Complex, alongside a blend of glucose proteins, the shampoo gently cleanses hair whilst also replenishing lost moisture and hydration. The result is hair that feels super soft and healthy without being weighed down.',
            link: '',
          },
          {
            sku: '10451618',
            title: 'Pureology Hydate Colour Care Shampoo',
            description:
              'Ideal for those with dry and damaged hair that\'s also coloured, the <a href="https://www.lookfantastic.com/pureology-hydrate-colour-care-shampoo-250ml/10451618.html" target="_blank" rel="noopener">Pureology Hydrate Shampoo</a> protects your hair\'s vibrancy without compromising on nourishment and moisture.\r\n\r\nFormulated without sulfates, the shampoo gently cleanses without stripping hair colour or causing dehydration and dullness. Soft and lustrous locks are left behind, which also happen to smell beautiful thanks to Pureology\'s exclusive fragrance blend.',
            link: '',
          },
          {
            sku: '11340780',
            title: 'Shu Uemura Art of Hair Urban Moisture Shampoo',
            description:
              'Not only does this bottle of shampoo look visually enticing, the <a href="https://www.lookfantastic.com/shu-uemura-art-of-hair-urban-moisture-shampoo-300ml/11340780.html" target="_blank" rel="noopener">Shu Uemura Art of Hair Urban Moisture</a> helps to replenish lost hydration and repair any sign of damage and dullness.\r\n\r\nEnriched with red algae extract and moringa oil, the shampoo gently cleanses away impurities and leaves hair looking and feeling super soft, shiny and in its very best condition.',
            link: '',
          },
          {
            sku: '10360327',
            title: 'Alterna Caviar Anti-Ageing Seasilk Moisture Shampoo',
            description:
              'Perfect for tired, brittle and dulling hair, the <a href="https://www.lookfantastic.com/alterna-caviar-anti-ageing-seasilk-moisture-shampoo-250ml/10360327.html" target="_blank" rel="noopener">Alterna Caviar Anti-Ageing Seasilk Moisture Shampoo</a> also works wonders on more mature hair thanks to its blend of super- nourishing ingredients and extracts.\r\n\r\nIts sulphate-free formulation helps to keep more moisture within the hair than other shampoos, while also helping to prevent further damage from environmental and chemical aggressors. It is the perfect remedy to dry and damaged locks as it turns them super silky after just one wash.',
            link: '',
          },
          {
            sku: '11782242',
            title:
              "L'Or\u00e9al Professionnel Source Essentielle Ultimate Nourishment Duo",
            description:
              'We love this new little <a href="https://www.lookfantastic.com/l-oreal-professionnel-source-essentielle-ultimate-nourishment-duo/11782242.html" target="_blank" rel="noopener">Nourishment Duo from haircare experts L\'Or\u00e9al Professionnel</a>, which has just launched this month.\r\n\r\nContained in the set is a nourishing shampoo made from 96% naturally-derived ingredients such as sesame oil and jasmine flowers, which help to replenish lost moisture while gently caring for delicate locks, and a Dry Hair Balm, which works in just 5 minutes to repair damaged and dry strands.',
            link: '',
          },
          {
            sku: '11314963',
            title: 'System Professional Hydrate Shampoo',
            description:
              'If you haven\'t heard of System Professional before, you\'ll definitely want to add it to your haircare radar. Based on hair science, it works by actually interacting with the hair fibres to provide long-term benefits rather than simple short-term benefits.\r\n\r\nTheir <a href="https://www.lookfantastic.com/system-professional-hydrate-shampoo-250ml/11314963.html" target="_blank" rel="noopener">Hydrate Shampoo</a> is made with an Active Moisture Complex, alongside Pro Vitamin B5 to soften and fortify dry and damaged fibres and replenish lost moisture. The result is glossy and super hydrated, soft locks.',
            link: '',
          },
          {
            sku: '10878379',
            title: 'Aveda Dry Remedy Shampoo',
            description:
              'If you want to remedy dry hair with as little chemical interaction as possible, you will love <a href="https://www.lookfantastic.com/aveda-dry-remedy-shampoo-250ml/10878379.html" target="_blank" rel="noopener">Aveda\'s Dry Remedy Shampoo</a>. It\'s enriched with the brand\'s unique Deep Moisture Complex to penetrate into the hair shaft for long-lasting hydration, alongside a natural blend of oils and extracts such as buriti and pomegranate.\r\n\r\nDrenching your hair in moisture, it doesn\'t weigh the hair down or cause it to become heavy or oily quickly, making it perfect for anyone with finer locks.',
            link: '',
          },
          {
            sku: '10406410',
            title: 'Moroccanoil Moisture Repair Shampoo',
            description:
              'If you have coloured or dyed your hair, or it has been weakened by chemical or heating processes, you will absolutely love <a href="https://www.lookfantastic.com/moroccanoil-moisture-repair-shampoo-250ml/10406410.html" target="_blank" rel="noopener">Moroccanoil\'s Moisture Repair Shampoo</a>.\r\n\r\nEnriched with argan oil (which is packed full of antioxidants), the shhampoo not only gently cleanses away impurities, but also helps to deeply condition and nourish. It also contains fortifying keratin and omega fatty acids to replenish lost moisture and keep the hair shiny and healthy.',
            link: '',
          },
          {
            sku: '11220560',
            title: 'Leonor Greyl Bain Vitalisant B',
            description:
              'Free from silicones, parabens and SLS, <a href="https://www.lookfantastic.com/leonor-greyl-bain-vitalisant-b-specific-shampoo-for-dry-colored-sensitive-hair/11220560.html" target="_blank" rel="noopener">Leonor Greyl\'s Bain Vitalisant B </a>is the ideal shampoo for anyone wanting to gently cleanse their hair while infusing it with essential moisture and hydration.\r\n\r\nPacked with nourishing botanicals like chamomile and jojoba, alongside vitamins and jojoba, the shampoo is perfect for anyone with slightly sensitised or coloured hair in need of a little TLC.',
            link: '',
          },
          {
            sku: '11425289',
            title: 'Biolage R.A.W Nourish Shampoo',
            description:
              'Another contender in the natural shampoo category is the <a href="https://www.lookfantastic.com/biolage-r.a.w.-nourish-shampoo-325ml/11425289.html" target="_blank" rel="noopener">Biolage R.A.W Nourish Shampoo</a>, which contains ingredients from 71% natural origin.\r\n\r\nInfused with quinoa husk to strengthen and fortify, the shampoo also contains honey to nourish and soften dehydrated, damaged and dry locks and leave them conditioned, healthy and shiny. It\'s also free from silicones, making it ideal for anyone with finer hair that wants moisture without it being weighed down.',
            link: '',
          },
        ],
      },
    },
    {
      node: 'element',
      type: 'header',
      props: {
        level: 3,
        text: 'Which are the best shampoos for dry and damaged hair?',
      },
    },
    {
      node: 'widget',
      type: 'postCard',
      props: {
        items: [
          {
            categoryUri: '/expert-advice/',
            categoryName: 'Expert Advice',
            postUri: '/expert-advice/how-to-get-perfect-skin/',
            title: 'How To Get Perfect Skin',
            excerpt:
              'Reverse the damage caused by the festive season and create a healthy skincare routine for 2021. ',
            date: '2363-10-04T01:00:00',
            displayName: 'Omorovicza',
            username: 'omorovicza',
            image:
              'https://blogscdn.thehut.net/app/uploads/sites/1013/2020/11/How-To-Get-Perfect-Skin_1608650524.png',
          },
          {
            categoryUri: '/ethos/',
            categoryName: 'Ethos',
            postUri: '/expert-advice/how-to-get-perfect-skin/',
            title:
              'Omorovicza Skincare: The Healing Powers Of Budapest’s Thermal Baths',
            excerpt:
              'Omorovicza skincare is inspired by Budapest’s thermal baths and their healing waters. It harnesses the powerful minerals to create a unique skincare range that makes skin appear younger and healthier.',
            date: '2363-10-04T01:00:00',
            displayName: 'Omorovicza',
            username: 'omorovicza',
            image:
              'https://blogscdn.thehut.net/app/uploads/sites/1053/2020/10/Omorovicza-skincare_1603114143.jpg',
          },
        ],
      },
    },
    {
      node: 'widget',
      type: 'highlightBox',
      props: {
        heading: 'Macros',
        children: [
          {
            node: 'element',
            type: 'header',
            props: {
              level: 2,
              text:
                'Note: the following will differ according to different brands',
            },
          },
          {
            node: 'element',
            type: 'p',
            props: {
              text: 'Calories: 312 Protein: 34g Fat: 2g Carbs: 38g',
            },
          },
          {
            node: 'element',
            type: 'text',
            props: {
              text: 'Calories from fat: 300',
            },
          },
        ],
      },
    },
    {
      node: 'widget',
      type: 'qa',
      props: {
        items: [
          {
            question: 'What is myofibrillar hypertrophy?',
            answer:
              'Myofibrillar hypertrophy is caused by stimulating muscle fibres with heavy weights, leading to breakdown of muscle fibres. Your body then repairs these fibres with increased volume and density of the myofibrills.',
          },
          {
            question: 'What is sarcoplasmic hypertrophy?',
            answer:
              'Sarcoplasmic hypertrophy is when the volume of sarcoplasmic fluid in the muscle cells increases, resulting in increased overall muscle volume without a difference in strength or fibre size.',
          },
          {
            question: 'How should I train for sarcoplasmic hypertrophy?',
            answer:
              "Typically for sarcoplasmic hypertrophy you should aim to 'pump up' the muscles with moderate weight, high reps, and low rest periods.",
          },
          {
            question: 'How should I train for myofibrill hypertrophy?',
            answer:
              'For myofibrill hypertrophy you should train with very heavy weights and longer rest periods between sets.',
          },
        ],
      },
    },
    {
      node: 'widget',
      type: 'imageCarousel',
      props: {
        items: [
          {
            alt: '',
            src: [
              {
                url:
                  'https://blogscdn.thehut.net/wp-content/uploads/sites/478/2014/12/27233631/deadlift-conventional.png',
              },
            ],
            width: '',
            height: '',
          },
          {
            alt: '',
            src: [
              {
                url:
                  'https://blogscdn.thehut.net/wp-content/uploads/sites/478/2014/12/27233642/deadlift-romanian.jpg',
              },
            ],
            width: '',
            height: '',
          },
          {
            width: '580',
            height: '300',
            alt: '',
            src: [
              {
                url:
                  'https://blogscdn.thehut.net/wp-content/uploads/sites/478/2014/12/27233617/deadlift-9.jpg',
              },
            ],
          },
          {
            width: '580',
            height: '300',
            alt: '',
            src: [
              {
                url:
                  'https://blogscdn.thehut.net/wp-content/uploads/sites/478/2014/12/27233642/deadlift-overhand-grio.jpg',
              },
            ],
          },
        ],
      },
    },
    {
      node: 'widget',
      type: 'tutorial',
      props: {
        items: [
          {
            images: [
              {
                alt: '',
                src: [
                  {
                    url:
                      'https://blogscdn.thehut.net/app/uploads/sites/1013/2021/02/JET190730-CJ-MYV-Batching-SHOT-026-1800x672_1577193077_1613574233-1200x448.jpg',
                  },
                ],
                width: '',
                height: '',
              },
              {
                alt: '',
                src: [
                  {
                    url:
                      'https://blogscdn.thehut.net/app/uploads/sites/1013/2021/02/Omorovicza-healing-concentrate_1612276047.jpg',
                  },
                ],
                width: '',
                height: '',
              },
              {
                alt: '',
                src: [
                  {
                    url:
                      'https://blogscdn.thehut.net/app/uploads/sites/1013/2021/02/Anti-Aging-Facials_1612276333.jpg',
                  },
                ],
                width: '',
                height: '',
              },
            ],
            title: 'Prep the Hair',
            content:
              'Prepping your To prep your hair for styling, wash with a nourishing shampoo and conditioner like the All Soft range. Towel dry and then apply Velvet Gelatine and Align 12 to the hair. \r\n\r\nYou only need a small amount each time. Apply to the palms of the hands and then run all over the hair, focusing on the ends and lengths. \r\n\r\nTogether, these help protect your hair from heat, speed up drying time and keep hair as smooth as possible. ',
          },
          {
            images: [
              {
                alt: '',
                src: [
                  {
                    url:
                      'https://blogscdn.thehut.net/app/uploads/sites/1013/2020/11/Omorovicza-skincare_1604913938.jpg',
                  },
                ],
                width: '',
                height: '',
              },
            ],
            title: 'Blow Dry First',
            content:
              "To get your hair as sleek as possible, first blow dry it. Using a barrel brush, blow dry section by section, smoothing the hair as you go. \r\n\r\nRaymond's top tip is to use this point to part your hair where you want and blow dry it in the right direction. Doing this at this moment will help your hair lie and flat and sleek as possible. \r\n",
          },
          {
            images: [
              {
                alt: '',
                src: [
                  {
                    url:
                      'https://blogscdn.thehut.net/app/uploads/sites/1013/2021/02/Omorovicza-healing-concentrate_1612276047.jpg',
                  },
                ],
                width: '',
                height: '',
              },
              {
                alt: '',
                src: [
                  {
                    url:
                      'https://blogscdn.thehut.net/app/uploads/sites/1013/2020/12/omorovicza-midnight-renewal_1608109890-672x672.jpg',
                  },
                ],
                width: '',
                height: '',
              },
            ],
            title: 'Finish off with Straighteners',
            content:
              'Once your hair has been blow dried, finish everything off by straightening your hair. Spritz with Quick Dry 18 to help set the style and straighten section by section from root to tip. \r\n\r\nFor that runway ready high shine finish, make sure to mist over the Diamond Oil Shine Spray. Not only will it give that gorgeous gloss but it will also help nourish your hair after all that heat. ',
          },
        ],
      },
    },
    {
      node: 'widget',
      type: 'topNItem',
      props: {
        items: [
          {
            image:
              'https://blogscdn.thehut.net/app/uploads/sites/1013/2020/11/Omorovicza-skincare_1604913938.jpg',
            title: 'A basic item',
            description:
              'Once your hair has been blow dried, finish everything off by straightening your hair. Spritz with Quick Dry 18 to help set the style and straighten section by section f',
            link: '',
          },
          {
            image:
              'https://blogscdn.thehut.net/app/uploads/sites/1013/2021/02/Omorovicza-healing-concentrate_1612276047.jpg',
            title: 'Another basic item',
            description:
              "To get your hair as sleek as possible, first blow dry it. Using a barrel brush, blow dry section by section, smoothing the hair as you go. \r\n\r\nRaymond's top tip is to ",
            link: '',
          },
          {
            image:
              'https://blogscdn.thehut.net/app/uploads/sites/1013/2021/02/Anti-Aging-Facials_1612276333.jpg',
            title: 'Basic item',
            description:
              'Omorovicza skincare is inspired by Budapest’s thermal baths and their healing waters. It harnesses the powerful minerals to create a unique skincare range that makes skin appear younger and healthier.',
            link: '',
          },
        ],
      },
    },
    {
      node: 'widget',
      type: 'figure',
      props: {
        image: {
          width: '780',
          height: '500',
          alt: 'Jessica Biel Blue Eyeliner',
          src: [
            {
              url:
                'https://blogscdn.thehut.net/app/uploads/sites/1013/2020/11/How-To-Get-Perfect-Skin_1608650524.png',
            },
          ],
        },
        caption: 'Image courtesy of Rex Images by Shutterstock',
      },
    },
    {
      node: 'widget',
      type: 'recipeDetails',
      props: {
        title: 'Who says you can’t have your own Wing Wednesday at home?',
        description:
          '<p>Find yourself craving all the things you suddenly can’t get as easily as before? Specifically, a pint and a platter of wings at the pub with your friends?</p>\n<p>Well, don’t worry about it — we’ve got your back with these delicious sticky Asian wings for you to make from the comfort of your own home. And what better time than now to put a new recipe to the test?</p>\n<p>Served with a crisp & crunchy healthy slaw, it’s the ideal fakeaway dinner to put a smile on your face.</p>\n',
        servings: '6 people',
        prepTime: '20 minutes',
        cookTime: '1 hour',
        passiveTime: '30 minutes',
      },
    },
    {
      node: 'widget',
      type: 'recipeIngredients',
      props: {
        ingredients: [
          {
            quantity: '100',
            unit: 'g',
            ingredient: 'Sugar Free Sauce',
            notes: '(Sweet Chilli)',
          },
          { quantity: '1/2', unit: 'tbsp.', ingredient: 'salt' },
          { quantity: '0.5', unit: 'tbsp.', ingredient: 'pepper' },
          { quantity: '1/100', unit: 'kg', ingredient: 'Chicken Wings' },
        ],
      },
    },
    {
      node: 'widget',
      type: 'recipeInstructions',
      props: {
        instructions: [
          {
            instruction: '<p>First, preheat the oven to 180°C.</p>\n',
            image: {
              src: [
                {
                  url:
                    'https://blogscdn.thehut.net/app/uploads/sites/1362/2021/04/chickenWings_1618409778.jpg',
                },
              ],
              alt: 'Chicken Wings',
              height: 'auto',
              width: '100%',
            },
          },
          {
            instruction:
              '<p>In a large bowl, make the coating for the wings by adding the cornflour, salt, and pepper and mixing well. Then add each chicken wing to the mixture and make sure to turn it about so that it’s fully coated in flour.</p>\n',
            image: {
              src: [
                {
                  url:
                    'https://blogscdn.thehut.net/app/uploads/sites/1362/2021/04/chickenWings_1618409778.jpg',
                },
              ],
              alt: 'Chicken Wings again',
              height: 'auto',
              width: '100%',
            },
          },
        ],
      },
    },
    {
      node: 'widget',
      type: 'recipeNutrition',
      props: {
        nutritionalInformation: {
          calories: 211,
          totalFat: 3,
          totalCarbohydrates: 21,
        },
      },
    },
    {
      node: 'widget',
      type: 'globalLinkCards',
      props: {
        heading: 'Find your perfect product:',
        displayMode: 'background',
        items: [
          {
            image: {
              src: [
                {
                  url:
                    'https://s1.thcdn.com/productimg/300/300/10485098-9444620643710144.jpg',
                },
              ],
              alt: 'BBQ',
              height: 'auto',
              width: '100%',
            },
            name: 'Shop this category',
            link: '',
          },
          {
            image: {
              src: [
                {
                  url:
                    'https://s1.thcdn.com/productimg/300/300/10485098-9444620643710144.jpg',
                },
              ],
              alt: 'Chimenea',
              height: 'auto',
              width: '100%',
            },
            name: 'Shop this category',
            link: '',
          },
          {
            image: {
              src: [
                {
                  url:
                    'https://s1.thcdn.com/productimg/300/300/10485098-9444620643710144.jpg',
                },
              ],
              alt: 'Another BBQ',
              height: 'auto',
              width: '100%',
            },
            name: 'Shop this category',
            link: '',
          },
          {
            image: {
              src: [
                {
                  url:
                    'https://s1.thcdn.com/productimg/300/300/10485098-9444620643710144.jpg',
                },
              ],
              alt: '',
              height: '',
              width: '',
            },
            name: 'Shop this category',
            link: '',
          },
        ],
      },
    },
    {
      node: 'widget',
      type: 'macronutrientCalculator',
      props: {},
    },
    {
      node: 'widget',
      type: 'disclaimer',
      props: {
        text:
          'Our articles should be used for informational and educational purposes only and are not intended to be taken as medical advice. If you’re concerned, consult a health professional before taking dietary supplements or introducing any major changes to your diet.',
      },
    },
  ],
}
